export default [
  {
    title: "Grupos",
    field: "grupos",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  },
  {
    title: "Mensajes",
    field: "mensajes",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  },
  {
    title: "Permisos",
    field: "permisos",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  },
  {
    title: "Salas",
    field: "salas",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  },
  {
    title: "Usuarios",
    field: "usuarios",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  },
  {
    title: "VideoConferencias",
    field: "videoconferencia",
    values: [
      {
        title: "Creación",
        field: "creacion",
        value: false
      },
      {
        title: "Modificación",
        field: "modificacion",
        value: false
      }
    ]
  }
];
